import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { ELSIconV2 } from 'components/common';
import { appSelectors } from 'redux/ducks/app';
import { clarityDataIconFeatureFlags } from 'constants/app.constant';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { PS_PATHS } from 'reports/ps/constants';
import { checkPathMatchV2 } from 'helpers/app.helper';
var InfoIcon = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'xs' : _c, _d = _a.dashboard, dashboard = _d === void 0 ? 'ps' : _d, _e = _a.id, id = _e === void 0 ? '' : _e, _f = _a.customClassName, customClassName = _f === void 0 ? '' : _f, a11yName = _a.a11yName, a11yDescription = _a.a11yDescription;
    var isPsDashboard = checkPathMatchV2(Object.values(PS_PATHS));
    var finalDashboard = isPsDashboard ? 'ps' : dashboard;
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isVisible = isFeatureEnabled(featureFlags, clarityDataIconFeatureFlags[finalDashboard]);
    if (!isVisible) {
        return null;
    }
    return (<ELSIconV2 sprite="InformationOutlineCircle" size={size} id={id} className={cx("u-els-color-secondary js-pendo-".concat(id), (_b = {}, _b[customClassName] = customClassName.length, _b))} a11y={a11yName ? { name: a11yName, description: a11yDescription !== null && a11yDescription !== void 0 ? a11yDescription : a11yName } : undefined}/>);
};
export default InfoIcon;
